// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"d3-z","colorTextValue":"e3-z","swatches":"f3-z","collapseLink":"g3-z","isCollapsed":"h3-z","dropdown":"i3-z","disabled":"j3-z"};